import React, { createContext, useContext } from 'react';

type UpdatingContextValue = React.Dispatch<React.SetStateAction<boolean>>;

const UpdatingContext = createContext<UpdatingContextValue | null>(null);

export const UpdatingProvider = ({
	setUpdating,
	children,
}: React.PropsWithChildren<{ setUpdating: UpdatingContextValue }>): React.ReactElement => (
	<UpdatingContext.Provider value={setUpdating}>{children}</UpdatingContext.Provider>
);

export const useSetUpdating = (): UpdatingContextValue => {
	const setUpdating = useContext(UpdatingContext);
	if (!setUpdating) {
		throw new Error('useSetUpdating must be used within an UpdatingProvider');
	}
	return setUpdating;
};
